import * as React from "react";
import { grid } from "../../design-tokens/grid";
import { Device } from "../../design-tokens/media-queries";
import { Card } from "../card";

interface SectionCardProps {
  className?: string;
}

const SectionCard: React.FC<SectionCardProps> = ({ className, children }) => {
  return (
    <Card
      css={{
        position: "relative",
        padding: `${grid(2)} ${grid(2)} ${grid(3)}`,
        marginBottom: grid(2),

        [Device.DesktopTablet]: {
          padding: `${grid(3)} ${grid(5)} ${grid(4)}`,
          marginBottom: grid(3),
        },

        [Device.Tablet]: {
          padding: `${grid(3)} ${grid(3)} ${grid(4)}`,
        },

        [Device.Mobile]: {
          borderRadius: 0,
        },
      }}
      className={className}
    >
      {children}
    </Card>
  );
};

export default SectionCard;
